/**
 * Homepage polish: reveals the stock theme sections as they scroll into view.
 *
 * Kalai's own sections animate their own contents, so they are skipped here to
 * avoid a double fade. The first section (hero) is shown immediately.
 */

const REVEALED_CLASS = 'kalai-revealed';

document.documentElement.classList.add('kalai-home');

const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const container = document.querySelector('main') ?? document.body;
const sections = /** @type {HTMLElement[]} */ (
  [...container.children].filter((el) => el instanceof HTMLElement && el.id.startsWith('shopify-section-'))
);

const candidates = sections.filter((el, index) => index > 0 && !el.querySelector('.kalai'));

if (candidates.length > 0) {
  if (!('IntersectionObserver' in window) || prefersReducedMotion()) {
    for (const el of candidates) el.classList.add(REVEALED_CLASS);
  } else {
    for (const el of candidates) el.setAttribute('data-kalai-reveal', '');

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add(REVEALED_CLASS);
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    for (const el of candidates) observer.observe(el);
  }
}
